const phoneRegex = /^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/;

export const prettifyPhone = (phone: string) =>
    phone.replace(phoneRegex, '+$1 $2 $3-$4-$5');
